import { render } from "./CardHorizontal.vue?vue&type=template&id=0e24524e&scoped=true"
import script from "./CardHorizontal.vue?vue&type=script&lang=js"
export * from "./CardHorizontal.vue?vue&type=script&lang=js"

import "./CardHorizontal.vue?vue&type=style&index=0&id=0e24524e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\GameToGo\\Desktop\\ecommerce-movie7-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e24524e"]])

export default __exports__